import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/login'; 
import  DisplayURLParameters   from "./components/callpopup";
import Comtemplete from './page/comtemplete';
import Queuepage from './page/queuepage';
function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);
    
    const handleLogin = (username) => {
    setLoggedInUser(username);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login onLogin={handleLogin} />} />
        <Route path="/callpopup" element={<DisplayURLParameters />} />
        <Route path="/queuepage" element={<Queuepage/>} />
        <Route path="/template" element={<Comtemplete/>} />
        </Routes>
    </Router>
  );
}

export default App;
